import React from 'react'

const JS_Essentials_Assignment_2 = () => {
  return (
    <div>
      <h1>JS Essentials Assignment 2</h1>
    </div>
  )
}

export default JS_Essentials_Assignment_2
